import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import { useLogout } from '@/hooks/login';
import { useTranslation } from '@/hooks/translation';
import BasicInfo from './BasicInfo';
import PaymentInfo from './PaymentInfo';
import styles from './steps.module.scss';

export default function Main(props) {
  const { onEdit, onDismiss, onPayPastDue, onEditPaymentMethod } = props;
  const { isLoading, logout } = useLogout({ onSuccess: hideOnLogout });
  const { t } = useTranslation();


  function hideOnLogout() {
    onDismiss();
  }

  return (
    <div className={styles.container}>
      <div>
        <BasicInfo onEdit={onEdit} />

        <PaymentInfo
          onPayPastDue={onPayPastDue}
          onEditPaymentMethod={onEditPaymentMethod}
        />
      </div>

      <div className={styles.modalCTAs}>
        <div>
          <Button className={styles.logoutButton} onClick={logout} loading={isLoading}>
            {t('user.profile.logout_cta')}
          </Button>
        </div>

        <div>
          <Link href="/legal/terms-and-conditions">
            <a target="_blank" rel="noopener noreferrer">
              {t('user.profile.terms_and_condition')}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}

Main.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onPayPastDue: PropTypes.func.isRequired,
  onEditPaymentMethod: PropTypes.func.isRequired,
};
